import { render, staticRenderFns } from "./JsonAdder.vue?vue&type=template&id=273b9826&scoped=true&"
import script from "./JsonAdder.vue?vue&type=script&lang=js&"
export * from "./JsonAdder.vue?vue&type=script&lang=js&"
import style0 from "./JsonAdder.vue?vue&type=style&index=0&id=273b9826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b9826",
  null
  
)

export default component.exports